import { Fragment } from 'react';

import PortfolioCopiesPage from '@/views/pages/CopyTrade/Follower/PortfolioCopiesPage';
import HomeCP from '@/views/pages/CopyTrade/Unauthorized/HomeCP';
import PortfolioManagement from '@/views/pages/CopyTrade/Master/PortfolioManagement';
import PriceboardPage from '@/views/pages/PriceboardPage';
import FollowerHistoryTransactionsPageComponent from '@/views/components/CopyTrade/Follower/FollowerHistoryTransactions/FollowerHistoryTransactionsComponent';
import { Backdrop, CircularProgress } from '@mui/material';
import PortfolioCopyFollowerNoDataPage from '@/views/pages/CopyTrade/Follower/PortfolioCopyFollowerNoDataPage';
import FollowerHistoryTransactionsNoDataPage from '@/views/pages/CopyTrade/Follower/FollowerHistoryTransactionsNoDataPage';
import RequirePermissionPage from '@/views/pages/CopyTrade/Follower/RequirePermissionPage';
import { useGetCosInfoStatus, useGetGlobalStateLoading, useGetStarted } from '@/controllers/gridManager/appManager/appManager';
import MasterTradeHistory from '@/views/pages/CopyTrade/Master/MasterTradeHistory';

const ComponentShare = (props: any) => {
    const { started } = useGetStarted();
    const { setCosInfoStatus } = useGetCosInfoStatus()
    const { stateLoading } = useGetGlobalStateLoading()

    const { componentName, callBackFunc } = props;

    console.log('ha_check_ComponentShare', { componentName });

    const renderComponent = (componentName: string) => {
        if (started && setCosInfoStatus === true) {
            switch (componentName) {
                case 'TEST':
                    return (
                        <PriceboardPage callBackFunc={callBackFunc} />
                    );
                case 'HomeCP':
                    return (
                        <HomeCP callBackFunc={callBackFunc} />
                    );
                case 'PortfolioCopyFollower':
                    return (
                        <PortfolioCopiesPage callBackFunc={callBackFunc} />
                    )
                case 'PortfolioCopyFollowerNoData':
                    return (
                        <PortfolioCopyFollowerNoDataPage callBackFunc={callBackFunc} />
                    )
                case 'FollowerHistoryTransactionsNoData':
                    return (
                        <FollowerHistoryTransactionsNoDataPage callBackFunc={callBackFunc} />
                    )
                case 'PortfolioManagement':
                    return (
                        <PortfolioManagement callBackFunc={callBackFunc} />
                    );
                case 'TransactionHistory':
                    return (
                        <MasterTradeHistory callBackFunc={callBackFunc} />
                    )
                case 'TransactionHistoryFollower':
                    return (
                        <FollowerHistoryTransactionsPageComponent callBackFunc={callBackFunc} />
                    )
                case 'RequirePermission':
                    return (
                        <RequirePermissionPage callBackFunc={callBackFunc} />
                    )
                default:
                    return (
                        <>404</>
                    );
            }
        }
        else {
            if (componentName === 'RequirePermission') {
                return <RequirePermissionPage callBackFunc={callBackFunc} />
            }

            return (
                <>
                </>
            );
        }
    }

    return (
        <Fragment>
            {renderComponent(componentName)}
            <Backdrop
                sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.modal + 1 })}
                open={stateLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </Fragment>
    );
};


export default ComponentShare;